import React from "react";
import { Modal, Button } from "react-bootstrap";

function AboutModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          <h3>About - Let's Teach English Program</h3>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
        Let's Teach English is an ACT (APR Charitable Trust) initiative. Please enter the details of the student who would like to learn English through this programme. We will add the student to the waitlist. As and when we have available teachers, we shall connect the student and the teacher.
          
        </p>
        <p>Let's Teach English is a FREE programme.</p>
      </Modal.Body>

      <Modal.Footer>
        <Button type="button" variant="primary" onClick={props.onHide}>
          CLOSE
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AboutModal;
